import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import Filter from './components/Filter';
import DataList from './components/DataList';
import mitreData from './data/mitreData.json';
import NotFound from './components/404';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

function App() {
  const [filteredData, setFilteredData] = useState(mitreData);
  const [categories, setCategories] = useState([]);
  const [techniques, setTechniques] = useState([]);
  const [tactics, setTactics] = useState([]);
  const [versions, setVersions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedTechniques, setSelectedTechniques] = useState([]);
  const [selectedTactics, setSelectedTactics] = useState([]);
  const [selectedVersions, setSelectedVersions] = useState([]);
  const [theme, setTheme] = useState('dark'); // Default to dark theme

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  useEffect(() => {
    const uniqueCategories = [...new Set(mitreData.flatMap(item => item.category || []))];
    setCategories(uniqueCategories);

    const uniqueTechniques = [...new Set(mitreData.flatMap(item => item.techniques || []))];
    setTechniques(uniqueTechniques);

    const uniqueTactics = [...new Set(mitreData.flatMap(item => item.tactics || []))];
    setTactics(uniqueTactics);

    const uniqueVersions = [...new Set(mitreData.flatMap(item => item.version || []))];
    setVersions(uniqueVersions);
  }, []);

  const handleFilter = (categories, techniques, tactics, versions, searchTerm = '') => {
    let filtered = mitreData;

    if (categories && categories.length > 0 && categories !== 'All') {
    filtered = filtered.filter(item =>
      categories.every(category => item.category.includes(category))
    );
  }

    if (techniques.length > 0) {
      filtered = filtered.filter(item =>
        techniques.every(technique => item.techniques.includes(technique))
      );
    }

    if (tactics.length > 0) {
      filtered = filtered.filter(item =>
        tactics.every(tactic => item.tactics.includes(tactic))
      );
    }

    if (versions.length > 0) {
      filtered = filtered.filter(item =>
        versions.every(version => item.version.includes(version))
      );
    }

    if (searchTerm) {
      filtered = filtered.filter(item =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.description.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1); // Reset to the first page after filtering
  };

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  const handleSearchChange = (e) => {
    const searchValue = e.target.value;
    setSearchTerm(searchValue);
    handleFilter(selectedCategory, selectedTechniques, selectedTactics, selectedVersions, searchValue);
  };

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    
    <div className={`App ${theme}`}>
      <div className="theme-toggle" onClick={toggleTheme}>
        <FontAwesomeIcon icon={theme === 'light' ? faMoon : faSun} />
      </div>
      <h1 style={{ fontFamily: 'Bungee Tint, cursive' }}>Volatility Plugin Directory</h1>

      {/* Search Input */}
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleSearchChange}
        className="search-input"
      />

      {/* Filters */}
      <Filter 
        categories={categories}
        techniques={techniques}
        tactics={tactics}
        versions={versions}
        onFilter={handleFilter} 
        selectedCategory={selectedCategory}
        selectedTechniques={selectedTechniques}
        selectedTactics={selectedTactics}
        selectedVersions={selectedVersions}
        setSelectedCategory={setSelectedCategory}
        setSelectedTechniques={setSelectedTechniques}
        setSelectedTactics={setSelectedTactics}
        setSelectedVersions={setSelectedVersions}
      />

      {/* Display Total Entries */}
      <p style={{ fontFamily: "'Special Elite', system-ui" }}>Total Entries: {filteredData.length}</p>

      {/* Data List with Pagination */}
      <DataList data={currentItems} />

      {/* Pagination Controls */}
      <div className="pagination">
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index + 1}
            onClick={() => handlePageChange(index + 1)}
            className={currentPage === index + 1 ? 'active' : ''}
          >
            {index + 1}
          </button>
        ))}

            </div>
<footer className="footer-disclaimer">
        <p style={{ fontFamily: '"ECZAR", sans-serif' }}><strong>DISCLAIMER OF RIGHTS</strong></p>
        <p style={{ fontFamily: '"quicksand", sans-serif' }} className="footer-disclaimer-text">All rights to the plugins available on our platform are held by their respective authors or creators. We do not claim ownership of any plugins listed. Our role is to collect and organize these plugins, making them easy to find and access for users.
        We respect the intellectual property rights of plugin creators and aim to provide a user-friendly repository for discovering their work.</p>
      </footer>
    </div>


  );
}

export default App;
